<template>
  <div>
    <b-card>
      <b-overlay
        :show="load"
        variant="transparent"
      >
        <b-row class="align-items-center">
          <b-col
            v-for="(item, i) in cards"
            :key="item.icon"
            xl="2"
            sm="3"
            @click="itemClick(i)"
          >
            <b-media no-body>
              <b-media-aside class="mr-2">
                <b-avatar
                  size="48"
                  :variant="item.color"
                >
                  <feather-icon
                    size="24"
                    :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-1">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.title }}
                </h4>
                <b-card-text class="font-small-3 mb-0">
                  {{ item.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>

          <b-col
            v-if="!load"
            xl="2"
            sm="3"
            class="d-flex align-items-center"
          >
            <b-button
              variant="outline-success"
              @click="exportToExcel"
            >
              Exportar para Excel
            </b-button>
          </b-col>
        </b-row>
      </b-overlay>
    </b-card>

    <b-tab
      v-if="itemClidado === 0"
    >
      <b-table
        responsive
        striped
        bordered
        :fields="fieldsChamadas"
        :items="ligacoes"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortChamada"
        :sort-desc.sync="sortDescChamada"
      >

        <template #cell(data)="data">
          {{ formatarDataHora(data.item.data) }}
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="ligacoes.length"
        :per-page="perPage"
        align="center"
        size="md"
        class="my-0"
      />
    </b-tab>

    <b-col
      v-if="itemClidado === 1"
    >
      <b-table
        responsive
        striped
        :items="itemsSMS"
        :fields="fieldsSMS"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(show_details)="row">
          <b-form-checkbox
            v-model="row.detailsShowing"
            class="custom-control-primary"
            @change="row.toggleDetails"
          >
            <span class="vs-checkbox">
              <span class="vs-checkbox--check">
                <i class="vs-icon feather icon-check" />
              </span>
            </span>
            <span class="vs-label">{{ row.detailsShowing ? 'Esconder' : 'Descrição' }}</span>
          </b-form-checkbox>
        </template>

        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col
                md="12"
                class="mb-1"
              >
                <div
                  v-for="(key, i) in JSON.parse(row.item.observacao)"
                  :key="key"
                >
                  <span> <strong> {{ i }}: </strong> {{ key }}</span>
                </div>
              </b-col>
            </b-row>

            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              Esconder Descrição
            </b-button>
          </b-card>
        </template>

        <template #cell(data_envio)="data">
          {{ formatarDataHora(data.item.data_envio) }}
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="itemsSMS.length"
        :per-page="perPage"
        align="center"
        size="md"
        class="my-0"
      />
    </b-col>

    <b-col
      v-if="itemClidado === 2"
    >
      <b-table
        responsive
        striped
        :items="itemsEmails"
        :fields="fieldsEmails"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(data_envio)="data">
          {{ formatarDataHora(data.item.data_envio) }}
        </template>

      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="itemsEmails.length"
        :per-page="perPage"
        align="center"
        size="md"
        class="my-0"
      />

    </b-col>
    <b-col
      v-if="itemClidado === 3"
    >
      <b-table
        responsive
        striped
        :items="itemsWhatsApp"
        :fields="fieldsWhatsApp"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(show_details)="row">
          <b-form-checkbox
            v-model="row.detailsShowing"
            class="custom-control-primary"
            @change="row.toggleDetails"
          >
            <span class="vs-checkbox">
              <span class="vs-checkbox--check">
                <i class="vs-icon feather icon-check" />
              </span>
            </span>
            <span class="vs-label">{{ row.detailsShowing ? 'Esconder' : 'Descrição' }}</span>
          </b-form-checkbox>
        </template>

        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col
                md="12"
                class="mb-1"
              >
                <strong>Mensagem Enviada:</strong>
                <br>
                <span>{{ row.item.texto_sms }}</span>
              </b-col>
            </b-row>

            <b-button
              size="sm"
              variant="outline-secondary"
              @click="row.toggleDetails"
            >
              Esconder Descrição
            </b-button>
          </b-card>
        </template>

        <template #cell(telefone)="data">
          {{ phoneLabel(data.item.telefone) }}
        </template>

        <template #cell(cpf_cnpj)="data">
          {{ cpfCNPJ(data.item.cpf_cnpj) }}
        </template>

        <template #cell(data_envio)="data">
          {{ formatarDataHora(data.item.data_envio) }}
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="itemsWhatsApp.length"
        :per-page="perPage"
        align="center"
        size="md"
        class="my-0"
      />
    </b-col>

    <!-- NOVO: WhatsApp Oficial -->
    <b-col
      v-if="itemClidado === 4"
    >
      <b-table
        responsive
        striped
        :items="itemsWhatsAppOficial"
        :fields="fieldsWhatsAppOficial"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortByOficial"
        :sort-desc.sync="sortDescOficial"
      >
        <template #cell(data_envio)="data">
          {{ formatarDataHora(data.item.data_envio) }}
        </template>
        <template #cell(campanha_id)="data">
          {{ data.item.campanha_id || '-' }}
        </template>
        <template #cell(description)="data">
          <span style="white-space: pre-line;">{{ data.item.description }}</span>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="itemsWhatsAppOficial.length"
        :per-page="perPage"
        align="center"
        size="md"
        class="my-0"
      />
    </b-col>

  </div>
</template>

<script>

// IMmportando dependecias de estilos
import {
  BRow,
  BCol,
  VBPopover,
  BCard,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BCardText,
  BTable,
  BPagination,
  BFormCheckbox,
  BButton,
  BMedia,
  BOverlay,

} from 'bootstrap-vue'

import { mapState } from 'vuex'
import dayjs from 'dayjs'
// Importando mecanismo de requisições
import axios from '@/../axios-auth'

import { saveAs } from 'file-saver'
import ExcelJS from 'exceljs'

async function getDataToExported(
  totaisLigacoes,
  totaisSMS,
  totaisEmails,
  totaisWhatsApp,
  itemsLigacoes,
  itemsSMS,
  itemsEmails,
  itemsWhatsApp,
  getDateOrTimezone,
  cliente,
  totaisWhatsAppOficial = 0,
  itemsWhatsAppOficial = [],
) {
  const workbook = new ExcelJS.Workbook()

  const workSheetTotais = workbook.addWorksheet('Resumo')
  const worksheetLigacoes = workbook.addWorksheet('Ligações')
  const worksheetSms = workbook.addWorksheet('SMS')
  const worksheetEmails = workbook.addWorksheet('E-mails')
  const worksheetWhatsapp = workbook.addWorksheet('Whatsapp')
  const worksheetWhatsappOficial = workbook.addWorksheet('Whatsapp Oficial')

  workSheetTotais.columns = [
    { key: 'ligacoes', header: 'Ligações' },
    { key: 'sms', header: 'Sms' },
    { key: 'emails', header: 'E-mails' },
    { key: 'whatsapp', header: 'Whatsapp' },
    { key: 'whatsappOficial', header: 'Whatsapp Oficial' },
  ]
  worksheetLigacoes.columns = [
    { key: 'cliente_nome', header: 'NOME DO CLIENTE' },
    { key: 'cpf', header: 'CPF' },
    { key: 'telefone', header: 'TELEFONE' },
    { key: 'data', header: 'DATA' },
    { key: 'horario', header: 'HORÁRIO' },
    { key: 'resultado', header: 'RESULTADO' },
    { key: 'origem', header: 'ORIGEM' },
  ]
  worksheetSms.columns = [
    { key: 'credor', header: 'CREDOR' },
    { key: 'cliente_nome', header: 'NOME DO CLIENTE' },
    { key: 'telefone', header: 'TELEFONE' },
    { key: 'cpf', header: 'CPF' },
    { key: 'data', header: 'DATA' },
    { key: 'horario', header: 'HORÁRIO' },
  ]
  worksheetEmails.columns = [
    { key: 'credor', header: 'CREDOR' },
    { key: 'cliente_nome', header: 'NOME DO CLIENTE' },
    { key: 'email', header: 'EMAIL' },
    { key: 'cpf', header: 'CPF' },
    { key: 'data', header: 'DATA' },
    { key: 'horario', header: 'HORÁRIO' },
  ]
  worksheetWhatsapp.columns = [
    { key: 'credor', header: 'CREDOR' },
    { key: 'cliente_nome', header: 'NOME DO CLIENTE' },
    { key: 'telefone', header: 'TELEFONE' },
    { key: 'cpf', header: 'CPF' },
    { key: 'data', header: 'DATA' },
    { key: 'horario', header: 'HORÁRIO' },
  ]
  worksheetWhatsappOficial.columns = [
    { key: 'telefone', header: 'Telefone' },
    { key: 'data_envio', header: 'Data Envio' },
    { key: 'phone_id', header: 'Phone ID' },
    { key: 'dialog_id', header: 'Dialog ID' },
    { key: 'response_status', header: 'Response Status' },
  ]

  workSheetTotais.addRow([
    totaisLigacoes,
    totaisSMS,
    totaisEmails,
    totaisWhatsApp,
    totaisWhatsAppOficial,
  ])

  itemsLigacoes.map(item => {
    worksheetLigacoes.addRow([
      cliente.nome || '',
      cliente.cpf_cnpj || '',
      item.telefone || '',
      item.data ? getDateOrTimezone(item.data, 'data') : '',
      item.data ? getDateOrTimezone(item.data) : '',
      item.resultado,
      item.origem,
    ])
  })
  itemsSMS.map(item => {
    worksheetSms.addRow([
      item.credor_nome || '',
      cliente.nome || '',
      item.telefone || '',
      cliente.cpf_cnpj || '',
      item.data_envio ? getDateOrTimezone(item.data_envio, 'data') : '',
      item.data_envio ? getDateOrTimezone(item.data_envio) : '',
    ])
  })
  itemsEmails.map(item => {
    worksheetEmails.addRow([
      item.credor_nome || '',
      cliente.nome || '',
      item.email || '',
      cliente.cpf_cnpj || '',
      item.data_envio ? getDateOrTimezone(item.data_envio, 'data') : '',
      item.data_envio ? getDateOrTimezone(item.data_envio) : '',
    ])
  })
  itemsWhatsApp.map(item => {
    worksheetWhatsapp.addRow([
      item.credor_nome || '',
      cliente.nome || '',
      item.telefone || '',
      cliente.cpf_cnpj || '',
      item.data_envio ? getDateOrTimezone(item.data_envio, 'data') : '',
      item.data_envio ? getDateOrTimezone(item.data_envio) : '',
    ])
  })
  itemsWhatsAppOficial.forEach(item => {
    worksheetWhatsappOficial.addRow([
      item.telefone,
      item.data_envio,
      item.phone_id,
      item.dialog_id,
      item.response_status,
    ])
  })

  // ... (The rest of your styling and file writing code remains the same) ...

  worksheetLigacoes.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell({ includeEmpty: true }, cell => {
      if (rowNumber === 1) {
        cell.font = {
          name: 'Calibri',
          family: 2,
          bold: true,
          size: 11,
          color: { argb: 'FFFFFF' },
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'fd8426' },
        }
      }
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = {
        horizontal: 'center',
        vertical: 'center',
      }
    })
  })

  workSheetTotais.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell({ includeEmpty: true }, cell => {
      if (rowNumber === 1) {
        cell.font = {
          name: 'Calibri',
          family: 2,
          bold: true,
          size: 11,
          color: { argb: 'FFFFFF' },
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'fd8426' },
        }
      }
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = {
        horizontal: 'center',
        vertical: 'center',
      }
    })
  })
  workSheetTotais.columns.forEach(column => {
    let dataMax = 0
    column.eachCell({ includeEmpty: true }, cell => {
      const columnLength = cell.value ? cell.value.length : 15
      if (columnLength > dataMax) {
        dataMax = columnLength + 5
      }
    })
    column.width = dataMax < 15 ? 15 : dataMax
  })

  worksheetLigacoes.columns.forEach(column => {
    let dataMax = 0
    column.eachCell({ includeEmpty: true }, cell => {
      const columnLength = cell.value ? cell.value.length : 15
      if (columnLength > dataMax) {
        dataMax = columnLength + 5
      }
    })
    column.width = dataMax < 15 ? 15 : dataMax
  })

  worksheetSms.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell({ includeEmpty: true }, cell => {
      if (rowNumber === 1) {
        cell.font = {
          name: 'Calibri',
          family: 2,
          bold: true,
          size: 11,
          color: { argb: 'FFFFFF' },
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'fd8426' },
        }
      }
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = {
        horizontal: 'center',
        vertical: 'center',
      }
    })
  })
  worksheetSms.columns.forEach(column => {
    let dataMax = 0
    column.eachCell({ includeEmpty: true }, cell => {
      const columnLength = cell.value ? cell.value.length : 15
      if (columnLength > dataMax) {
        dataMax = columnLength + 5
      }
    })
    column.width = dataMax < 15 ? 15 : dataMax
  })

  worksheetEmails.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell({ includeEmpty: true }, cell => {
      if (rowNumber === 1) {
        cell.font = {
          name: 'Calibri',
          family: 2,
          bold: true,
          size: 11,
          color: { argb: 'FFFFFF' },
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'fd8426' },
        }
      }
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = {
        horizontal: 'center',
        vertical: 'center',
      }
    })
  })
  worksheetEmails.columns.forEach(column => {
    let dataMax = 0
    column.eachCell({ includeEmpty: true }, cell => {
      const columnLength = cell.value ? cell.value.length : 15
      if (columnLength > dataMax) {
        dataMax = columnLength + 5
      }
    })
    column.width = dataMax < 15 ? 15 : dataMax
  })

  worksheetWhatsapp.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell({ includeEmpty: true }, cell => {
      if (rowNumber === 1) {
        cell.font = {
          name: 'Calibri',
          family: 2,
          bold: true,
          size: 11,
          color: { argb: 'FFFFFF' },
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'fd8426' },
        }
      }
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = {
        horizontal: 'center',
        vertical: 'center',
      }
    })
  })

  worksheetWhatsapp.columns.forEach(column => {
    let dataMax = 0
    column.eachCell({ includeEmpty: true }, cell => {
      const columnLength = cell.value ? cell.value.length : 15
      if (columnLength > dataMax) {
        dataMax = columnLength + 5
      }
    })
    column.width = dataMax < 15 ? 15 : dataMax
  })

  // Estilização da tabela Whatsapp Oficial
  worksheetWhatsappOficial.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell({ includeEmpty: true }, cell => {
      if (rowNumber === 1) {
        cell.font = {
          name: 'Calibri',
          family: 2,
          bold: true,
          size: 11,
          color: { argb: 'FFFFFF' },
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'fd8426' },
        }
      }
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
      }
      cell.alignment = {
        horizontal: 'center',
        vertical: 'center',
      }
    })
  })
  worksheetWhatsappOficial.columns.forEach(column => {
    let dataMax = 0
    column.eachCell({ includeEmpty: true }, cell => {
      const columnLength = cell.value ? cell.value.length : 15
      if (columnLength > dataMax) {
        dataMax = columnLength + 5
      }
    })
    column.width = dataMax < 15 ? 15 : dataMax
  })

  let blob = null

  await workbook.xlsx.writeBuffer().then(data => {
    // eslint-disable-next-line camelcase
    blob = new File([data], 'Relatório Ações de Cobranças', {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
  })
  return blob
}

// exportToExcel now accepts all the data arguments and passes them to getDataToExported
async function exportToExcel(
  totaisLigacoes,
  totaisSMS,
  totaisEmails,
  totaisWhatsApp,
  itemsLigacoes,
  itemsSMS,
  itemsEmails,
  itemsWhatsApp,
  getDateOrTimezone,
  cliente,
  totaisWhatsAppOficial,
  itemsWhatsAppOficial,
) {
  const file = await getDataToExported(
    totaisLigacoes,
    totaisSMS,
    totaisEmails,
    totaisWhatsApp,
    itemsLigacoes,
    itemsSMS,
    itemsEmails,
    itemsWhatsApp,
    getDateOrTimezone,
    cliente,
    totaisWhatsAppOficial,
    itemsWhatsAppOficial,
  )
  if (file) {
    saveAs(file, 'relatorio_acoes_cobranca.xlsx')
  }
}

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
    BFormCheckbox,
    // BBadge,
    // BLink,
    BCard,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BCardText,
    BButton,
    BMedia,
    BOverlay,
  },
  directives: {
    'b-popover': VBPopover,
  },
  data() {
    return {
      itemsSMS: [],
      itemsEmails: [],
      itemsWhatsApp: [],
      itemsWhatsAppOficial: [],
      totaisWhatsAppOficial: 0,
      sortByOficial: 'created_at',
      sortDescOficial: true,
      fieldsWhatsAppOficial: [
        { key: 'telefone', label: 'Telefone', class: 'text-center' },
        { key: 'data_envio', label: 'Data Envio', class: 'text-center' },
        { key: 'campanha_id', label: 'Campanha', class: 'text-center' },
        { key: 'dialog_id', label: 'Dialog ID', class: 'text-center' },
        { key: 'response_status', label: 'Response Status', class: 'text-center' },
      ],

      itemClidado: null,
      tabelaClicada: null,
      ligacoes: [],
      itemSelected: [],
      userData: localStorage.getItem('funcao'),
      items: [],
      perPage: 15,
      currentPage: 1,
      cards: [],
      fieldsChamadas: [
        {
          key: 'data', label: 'DATA', class: 'text-center',
        },
        {
          key: 'telefone', label: 'TELEFONE', class: 'text-center',
        },
        { key: 'resultado', label: 'RESULTADO', class: 'text-center' },
        {
          key: 'origem', label: 'ORIGEM', class: 'text-center', sortable: true,
        },
      ],

      fieldsSMS: [
        { key: 'show_details', label: 'Mostrar Detalhes', class: 'text-center' },
        { key: 'credor_nome', label: 'Credor', class: 'text-center' },
        { key: 'data_envio', label: 'data envio', class: 'text-center' },
        { key: 'telefone', label: 'Telefone', class: 'text-center' },
      ],

      fieldsEmails: [
        { key: 'credor_nome', label: 'Credor', class: 'text-center' },
        { key: 'email', label: 'email', class: 'text-center' },
        { key: 'data_envio', label: 'data envio', class: 'text-center' },
      ],

      fieldsWhatsApp: [
        { key: 'show_details', label: 'Mostrar Detalhes', class: 'text-center' },
        { key: 'credor_nome', label: 'Credor', class: 'text-center' },
        { key: 'campanhas_id', label: 'ID Campanha', class: 'text-center' },
        { key: 'telefone', label: 'Telefone', class: 'text-center' },
        { key: 'cpf_cnpj', label: 'CPF/CNPJ', class: 'text-center' },
        { key: 'data_envio', label: 'data envio', class: 'text-center' },
        { key: 'username', label: 'usuário', class: 'text-center' },
      ],
      isCredor: localStorage.getItem('credores'),
      totaisLigacoes: 0,
      totaisSMS: 0,
      totaisEmails: 0,
      totaisWhatsApp: 0,
      sortBy: 'data_envio',
      sortDesc: true,
      sortChamada: 'data',
      sortDescChamada: true,
      load: false,
    }
  },
  computed: {
    ...mapState({
      cliente: state => {
        const { infoCliente } = state.negociacao
        return infoCliente
      },
    }),

  },
  async created() {
    await this.constroiPagina()
    this.setCards()
  },
  methods: {
    async itemClick(data) {
      this.itemClidado = data
    },
    agrupaligacoes(data) {
      const allLigacacoes = []
      data.ligacoesFastway.map(ligacao => {
        allLigacacoes.push({
          credor_nome: ligacao.credor_nome,
          telefone: ligacao.destino,
          data: ligacao.data_hora,
          origem: ligacao.origem_ligacao,
          resultado: ligacao.resultado,
        })
      })
      data.ligacoesPlure.map(ligacoes => allLigacacoes.push(ligacoes))

      return allLigacacoes
    },
    retornaSMSeWhatsapp(telefones) {
      const sms = []
      const zapzap = []

      telefones.map(telefone => {
        if (telefone.servico === 'Whatsapp' || telefone.servico === 'oficial') {
          zapzap.push(telefone)
        } else {
          sms.push(telefone)
        }
      })

      return [sms, zapzap]
    },

    async constroiPagina() {
      this.load = true
      const { cpf_cnpj: doc } = this.cliente
      await axios.get(`api/v1/dashboard/credor/info/cliente/${doc}`).then(res => {
        this.load = false

        this.itemsEmails = res.data.dados.emails
        this.totaisEmails = res.data.dados.emails.length

        // Sort ligacoes by date (most recent first)
        const allLigacoes = this.agrupaligacoes(res.data.dados).sort((a, b) => new Date(b.data) - new Date(a.data))
        this.ligacoes = allLigacoes
        this.totaisLigacoes = allLigacoes.length

        const [sms, zapzap] = this.retornaSMSeWhatsapp(res.data.dados.telefones)

        // Sort SMS by data_envio (most recent first)
        this.itemsSMS = sms.sort((a, b) => new Date(b.data_envio) - new Date(a.data_envio))
        this.totaisSMS = sms.length

        // Sort WhatsApp (inclui servico 'Whatsapp' e 'oficial', filtered for unique IDs) by data_envio (most recent first)
        this.itemsWhatsApp = zapzap.filter((obj, index, array) => array.findIndex(t => t.id === obj.id) === index)
          .sort((a, b) => new Date(b.data_envio) - new Date(a.data_envio))
        this.totaisWhatsApp = zapzap.length

        // WhatsApp Oficial
        this.itemsWhatsAppOficial = (res.data.dados.whatsappOficial || []).sort((a, b) => new Date(b.data_envio) - new Date(a.data_envio))
        this.totaisWhatsAppOficial = this.itemsWhatsAppOficial.length

        // Sort Email
        this.itemsEmails = this.itemsEmails.map(item => ({ ...item, credor_nome: res.data.dados.emails[0]?.credor_nome })).sort((a, b) => new Date(b.data_envio) - new Date(a.data_envio))
        this.itemsSMS = this.itemsSMS.map(item => ({ ...item, credor_nome: res.data.dados.telefones[0]?.credor_nome }))
        this.itemsWhatsApp = this.itemsWhatsApp.map(item => ({ ...item, credor_nome: res.data.dados.telefones[0]?.credor_nome }))
      })
    },

    setCards() {
      const cards = [
        {
          color: 'light-info',
          customClass: '',
          icon: 'ActivityIcon',
          subtitle: 'LIGAÇÕES',
          title: this.totaisLigacoes,
        },
        {
          color: 'light-danger',
          customClass: '',
          icon: 'AlertTriangleIcon',
          subtitle: 'SMS',
          title: this.totaisSMS,
        },
        {
          color: 'light-primary',
          customClass: '',
          icon: 'ClockIcon',
          subtitle: 'EMAILS',
          title: this.totaisEmails,
        },
        {
          color: 'light-info',
          customClass: '',
          icon: 'WhatsAppIcon',
          subtitle: 'WHATSAPP',
          title: this.totaisWhatsApp,
        },
        {
          color: 'light-success',
          customClass: '',
          icon: 'CheckCircleIcon',
          subtitle: 'OFICIAL',
          title: this.totaisWhatsAppOficial,
        },
      ]
      this.cards = cards
    },

    async exportToExcel() {
      await exportToExcel(
        this.totaisLigacoes,
        this.totaisSMS,
        this.totaisEmails,
        this.totaisWhatsApp,
        this.ligacoes,
        this.itemsSMS,
        this.itemsEmails,
        this.itemsWhatsApp,
        this.formatarDataHora,
        this.cliente,
        this.totaisWhatsAppOficial,
        this.itemsWhatsAppOficial,
      )
    },

    formatarDataHora(dados, type) {
      if (type === 'data') {
        return dayjs(dados).format('DD/MM/YYYY')
      }
      return dayjs(dados).format('DD/MM/YYYY HH:mm:ss')
    },
  },
}
</script>
